import { ExportTable } from 'shared/projects/ExportTable.ts';
import { CellValue } from 'shared/projects/CellValue.ts';
import { isLink } from 'shared/projects/isLink.ts';

const LABEL_COLUMN = 0;
const QTY_COLUMN = 1;

const getCellLabel = (cell: CellValue): string | undefined => {
    if (typeof cell === 'string') {
        return cell;
    }
    if (isLink(cell)) {
        return cell.text;
    }
    if (cell && typeof cell === 'object' && 'localized' in cell) {
        return cell.localized[0] ?? cell.raw[0];
    }
    return undefined;
};

/**
 * Updates the quantity of the row whose first column (product name) matches `label`.
 * The quantity lives in the cell immediately to the right of the name.
 * Returns a new table; the input is left untouched.
 */
export const updateQtyByLabel = (data: ExportTable, label: string, qty: number): ExportTable => ({
    ...data,
    rows: data.rows.map((row) => (
        getCellLabel(row[LABEL_COLUMN]) === label
            ? row.map((cell, index) => (index === QTY_COLUMN ? String(qty) : cell))
            : row
    )),
});

export const removeByLabel = (data: ExportTable, label: string): ExportTable => ({
    ...data,
    rows: data.rows.filter((row) => getCellLabel(row[LABEL_COLUMN]) !== label),
});
